<table aria-describedby="calendar">
  <colgroup>
  <col style="width:14%">
  <col style="width:14%">
  <col style="width:14%">
  <col style="width:14%">
  <col style="width:14%">
  <col style="width:14%">
  <col style="width:14%">
</colgroup>

<thead>
  <tr>
    <th scope="row" colspan="7">{{ name }} {{ year }}</th>
  </tr>
  <tr>
    <th scope="col">Lun</th>
    <th scope="col">Mar</th>
    <th scope="col">Mer</th>
    <th scope="col">Jeu</th>
    <th scope="col">Ven</th>
    <th scope="col">Sam</th>
    <th scope="col">Dim</th>
  </tr>
</thead>
<tbody>
  @for (week of weeks; track week) {
    <tr>
      @for (day of week; track day) {
        <td>
          @if (day.day > 0) {
            <div class="d-flex justify-content-center align-items-center"
              [class.style]="day.meeting !== undefined"
              [class.over]="day.meeting !== undefined && over !== undefined && over.id === day.meeting.id"
              [class.fw-bold]="todayMonth && day.day === today.getDate()"
              (mouseover)="overMeeting(day.meeting)"
              (mouseleave)="overMeeting(undefined)"
              >{{ day.day }}
            </div>
          }
          @if (day.day > 0) {
            <div class="d-sm-none phone-meeting" (click)="show(day.meeting)">
              @if (day.meeting !== undefined) {
                <p>{{ day.meeting.name }}</p>
              }
            </div>
          }
        </td>
      }
    </tr>
  }
</tbody>
</table>
